const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { specification: specificationApi } = require('@doctoroncallcom/api')
const {
  GET_SPECIFICATION_LIST,
  GET_SPECIFICATION,
  CREATE_SPECIFICATION,
  UPDATE_SPECIFICATION,
  DELETE_SPECIFICATION,
  GET_SPECIFICATION_PRICE,
} = require('./constants')

const {
  getSpecificationListSuccess,
  getSpecificationListError,
  getSpecificationSuccess,
  getSpecificationError,
  createSpecificationSuccess,
  createSpecificationError,
  updateSpecificationSuccess,
  updateSpecificationError,
  deleteSpecificationSuccess,
  deleteSpecificationError,
  getSpecificationPriceSuccess,
  getSpecificationPriceError,
} = require('./actions')

const getSpecificationsList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_SPECIFICATION_LIST),
  mergeMap(action => specificationApi.getSpecificationListApi(api, {
    search: action.payload.search,
    take: action.payload.take,
    skip: action.payload.skip,
  })
    .then(response => getSpecificationListSuccess(response.data))
    .catch(error => getSpecificationListError(error))),
)

const getSpecification = (action$, state$, { api }) => action$.pipe(
  ofType(GET_SPECIFICATION),
  mergeMap(action => specificationApi.getSpecificationApi(api, action.payload.id)
    .then(response => getSpecificationSuccess(response.data))
    .catch(error => getSpecificationError(error))),
)

const createSpecification = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_SPECIFICATION),
  mergeMap(action => specificationApi.createSpecificationApi(api, action.payload.specificationData)
    .then(response => createSpecificationSuccess(response.data))
    .catch(error => createSpecificationError(error))),
)

const updateSpecification = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_SPECIFICATION),
  mergeMap(action => specificationApi.updateSpecificationApi(api, action.payload.id, action.payload.specificationData)
    .then(response => updateSpecificationSuccess(response.data))
    .catch(error => updateSpecificationError(error))),
)

const deleteSpecification = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_SPECIFICATION),
  mergeMap(action => specificationApi.deleteSpecificationApi(api, action.payload.id)
    .then(response => deleteSpecificationSuccess(response.data))
    .catch(error => deleteSpecificationError(error))),
)

const getSpecificationPriceEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_SPECIFICATION_PRICE),
  mergeMap(action => specificationApi.getSpecificationPriceApi(api, action.payload.paramsData)
    .then(response => getSpecificationPriceSuccess(response.data))
    .catch(error => getSpecificationPriceError(error))),
)

module.exports = {
  getSpecificationsList,
  getSpecification,
  createSpecification,
  updateSpecification,
  deleteSpecification,
  getSpecificationPriceEpic,
}
